import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-maskedinput';
import './styles.css';

export default class MaskInput extends Component {
  render() {
    const { error, value, field, label, mask, placeholder } = this.props;
    return (
      <div className={`masked__input ${field}_input ${error ? 'text__input--error error' : ''}`}>
        <label htmlFor={label} className={value !== "" ? `masked__input__hidden masked__input__label` : `${field}__input__label type__input__label masked__input__label`}>{label}
        </label>
        <MaskedInput
          className={`${field}__input__field type__input__field  masked__input__field ${error ? 'error' : ''}`}
          name={field}
          mask={mask}
          placeholder={placeholder}
          value={value}
          onChange={this._onChange.bind(this)}
        />
      </div>
    )
  }
  // CUSTOM METHODS -----------------------------------------------
  _onChange(e) {
    this.props.onChange(e.target.value)
  }
};

MaskInput.propTypes = {
  error: PropTypes.bool.isRequired, 
  value: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  mask: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/components/MaskInput/MaskInput.js